<!--
 * @Author: your name
 * @Date: 2021-10-13 13:45:20
 * @LastEditTime: 2022-06-07 14:37:36
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-setting\process-order\forward\index.vue
-->
<template>
  <div class="app-container">
    <BjRouteTabs :route-list="STRATEGY_SOURCE_ROUTE_LIST"> </BjRouteTabs>
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:tableOperation="tableOperationProp">
        <div>
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane :label="$t('SettingOrderSourceStrategyParcel.title')" name="0" />
            <!-- <el-tab-pane label="套餐发包" name="1" />
            <el-tab-pane label="套餐拆单品发包" name="2" /> -->
          </el-tabs>
        </div>
        <div>
          <el-col>
            <el-button
              v-permission:SettingOrderSourceStrategyParcel_Delete
              type="primary"
              :disabled="tableOperationProp.notSelected"
              @click="onDeleteSelected"
              >{{ $t('delText') }}</el-button
            >
            <el-button
              v-permission:SettingOrderSourceStrategyParcel_Add
              type="primary"
              class="main-btn"
              @click="onAdd"
              >{{ $t('SettingOrderSourceStrategyParcel.rule') }}</el-button
            >
            <el-button
              v-permission:SettingOrderSourceStrategyParcel_Set1
              type="primary"
              @click="onExcludeSet"
              >{{ $t('SettingOrderSourceStrategyParcel.condition') }}</el-button
            >
            <el-button v-permission:SettingOrderSourceStrategyParcel_Set2 type="primary" disabled
              >{{ $t('SettingOrderSourceStrategyParcel.pack') }}</el-button
            >
          </el-col>
        </div>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
            :show-overflow-tooltip="col.prop !== 'bjTableAction'"
          >
            <template v-if="col.prop === 'splitNum'" slot="header">
              <span>
                {{ $t('SettingOrderSourceStrategyParcel.table.subcontract') }}
                <el-tooltip effect="dark" placement="top-start">
                  <div slot="content">
                    {{ $t('SettingOrderSourceStrategyParcel.hint1') }}<br />
                    {{ $t('SettingOrderSourceStrategyParcel.hint2') }}
                  </div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
            </template>

            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'splitNum'">
                <BjInputNumber
                  v-if="splitNumIds.includes(scope.row.id)"
                  v-model="scope.row[col.prop]"
                  :placeholder="$t('SettingOrderSourceStrategyParcel.unlimited')"
                  not-auto-zero
                  clearable
                />
                <span v-else>{{ scope.row[col.prop] ? scope.row[col.prop] : $t('SettingOrderSourceStrategyParcel.all') }}</span>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button
                v-if="!splitNumIds.includes(props.row.id)"
                v-permission:SettingOrderSourceStrategyParcel_Edit
                type="text"
                @click="onEdit(props.row)"
                >{{ $t('editText') }}</el-button
              >
              <el-button
                v-if="splitNumIds.includes(props.row.id)"
                v-permission:SettingOrderSourceStrategyParcel_Edit
                type="text"
                @click="onSave(props.row)"
                >{{ $t('saveText') }}</el-button
              >
              <el-button
                v-if="splitNumIds.includes(props.row.id)"
                v-permission:SettingOrderSourceStrategyParcel_Edit
                type="text"
                @click="onCancel(props.row)"
                >{{ $t('cancelText') }}</el-button
              >
              <el-button
                v-if="!splitNumIds.includes(props.row.id)"
                v-permission:SettingOrderSourceStrategyParcel_Delete
                type="text"
                @click="onDelete(props.row)"
                >{{ $t('delText') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 选择SKU -->
    <BjDialogList
      ref="dialogList"
      :config="$BjDialogListConfig.skuDefault()"
      width="85%"
      :right-span="10"
      :show-tags="false"
      multiple
      :before-confirm="beforeConfirm"
      @confirm="onConfirmDialogList"
    >
      <template v-slot:right="dialogProps">
        <el-row>
          <el-col class="text-right">
            <el-button type="danger" class="mb20" @click="onRightTableDeleteSelected"
              >{{ $t('SettingOrderSourceStrategyParcel.batchDeletion') }}</el-button
            ></el-col
          >
        </el-row>
        <vxe-table
          v-if="dialogProps.visible"
          ref="RightTable"
          :data="dialogProps.pagesSelectedRows"
          :max-height="dialogProps.maxHeight - 48"
          border
          :header-cell-style="$rowStyle.DEFAULT"
          :empty-text="$t('table.emptyText')"
          @checkbox-all="handleRightSelectionChange"
          @checkbox-change="handleRightSelectionChange"
        >
          <el-table-column type="selection" width="50" align="center" />
          <el-table-column :label="$t('table.countText')" type="index" width="80" align="center" />
          <el-table-column :label="$t('SettingOrderSourceStrategyParcel.table.skuCoding')" width="120" prop="skuCode" align="center" />
          <el-table-column :label="$t('SettingOrderSourceStrategyParcel.table.skuName')" width="120" prop="skuName" align="center" />
          <el-table-column :label="$t('SettingOrderSourceStrategyParcel.table.subcontract')" prop="splitNum" width="180" align="center">
            <template slot="header">
              <span>
                {{ $t('SettingOrderSourceStrategyParcel.table.subcontract') }}
                <el-tooltip effect="dark" placement="top-start">
                  <div slot="content">
                    {{ $t('SettingOrderSourceStrategyParcel.hint1') }}<br />
                    {{ $t('SettingOrderSourceStrategyParcel.hint2') }}
                  </div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
            </template>
            <template slot-scope="props">
              <BjInputNumber
                v-model="props.row.splitNum"
                :placeholder="$t('SettingOrderSourceStrategyParcel.unlimited')"
                not-auto-zero
                clearable
              />
            </template>
          </el-table-column>

          <el-table-column :label="$t('table.operationText')" width="100" align="center">
            <template slot-scope="props">
              <el-button type="text" @click="onRightTableDelete(props.row, props.$index)"
                >{{ $t('delText') }}</el-button
              >
            </template>
          </el-table-column>
        </vxe-table>
      </template>
    </BjDialogList>
    <!-- 排除条件设置 -->
    <dialogForm ref="dialogForm" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import { STRATEGY_SOURCE_ROUTE_LIST } from '@/utils/constants';
import dialogForm from './components/dialogForm';
export default {
  name: 'SettingOrderSourceStrategyParcel',
  components: {
    dialogForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 6,
      /** */
      STRATEGY_SOURCE_ROUTE_LIST,
      /** */
      queryApi: orderApi.getSouringStrategyPackage,
      // 查询参数
      queryParams: {},
      activeName: 0,
      labelsVersion: 11,
      tableSortableDisabled: true,
      labelList: [
        // { label: 'goodsPage.spuCode', prop: 'spuCode', isCheck: true, disabled: false },
        // { label: 'goodsPage.spuName', prop: 'spuName', isCheck: true, disabled: false },
        { label: 'SettingOrderSourceStrategyParcel.table.skuCoding', prop: 'skuCode', isCheck: true, disabled: false },
        { label: 'SettingOrderSourceStrategyParcel.table.skuName', prop: 'skuName', isCheck: true, disabled: false },
        { label: 'SettingOrderSourceStrategyParcel.table.subcontract', prop: 'splitNum', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
      ],
      restoreList: [],
      rightSelectedRows: [],
    };
  },
  computed: {
    splitNumIds() {
      return this.restoreList.map(item => item.id);
    },
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    getRightTableData() {
      return this.$refs.RightTable.getData();
    },
    // 右侧 选中回调
    handleRightSelectionChange({ records }) {
      this.rightSelectedRows = [...records];
    },
    // 右侧 选中删除
    onRightTableDeleteSelected() {
      const rightData = this.getRightTableData();
      this.rightSelectedRows.forEach(row => {
        const index = rightData.findIndex(e => e.skuCode == row.skuCode);
        if (index != -1) {
          this.$refs.dialogList.handleTagClose(row);
        }
      });
    },
    // 右侧 单个删除
    onRightTableDelete(row, index) {
      this.$refs.dialogList.handleTagClose(row);
    },
    // 右侧 确认 之前，先校验数据
    beforeConfirm(CONFIRM_DATA) {
      const rightData = this.getRightTableData();
      return new Promise((resolve, reject) => {
        if (
          rightData.every(e => {
            if (e.splitNum === 0 || e.splitNum === '0') {
              return false;
            }
            if (!e.splitNum) e.splitNum = '';
            return true;
          })
        ) {
          resolve(CONFIRM_DATA);
        } else {
          // 分包数量不能为0，请重新输入
          reject(this.$t('SettingOrderSourceStrategyParcel.rejectText'));
        }
      });
    },
    // 右侧 确认，数据回写
    onConfirmDialogList() {
      const rightData = this.getRightTableData();
      const API_DATA = rightData.map(e => {
        return {
          skuCode: e.skuCode,
          skuId: e.id,
          skuName: e.skuName,
          splitNum: e.splitNum == '' ? null : e.splitNum,
          spuCode: e.spuCode,
          spuName: e.spuName,
        };
      });
      this.batchAddApi(API_DATA);
    },
    handleClick() {
      this.reFresh();
    },
    // 列表  创建
    onAdd() {
      this.$refs.dialogList.show([]);
    },
    // 编辑
    onEdit(row) {
      this.restoreList.push(this.$lodash.clone(row));
    },
    // 列表 保存
    onSave(row) {
      // 判断用户是否修改了数据
      const DATA = this.restoreList.find(item => item.id === row.id);
      if (row.splitNum !== DATA.splitNum) {
        this.$confirm(
          this.$t('SettingOrderSourceStrategyParcel.confirmText1'),
          this.$t('toast.hintText'),
          {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          },
        )
          .then(() => {
            this.saveApi(row);
          })
          .catch(() => {});
      } else {
        this.restoreList.splice(0, 1);
      }
    },
    // 保存Api
    saveApi(row) {
      orderApi
        .updateSouringStrategyPackageBatch([{ id: row.id, num: row.splitNum }])
        .then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.restoreList = this.restoreList.filter(e => e.id !== row.id);
            this.$message.success(this.$t('toast.operationSuccessText'));
          }
        });
    },
    // 取消
    onCancel(row) {
      const index = this.$refs.BjPage.tableData.findIndex(e => e.id === row.id);
      this.$refs.BjPage.tableData.splice(
        index,
        1,
        this.restoreList.find(e => e.id === row.id),
      );
      this.restoreList = this.restoreList.filter(e => e.id !== row.id);
    },
    // 列表 删除
    onDelete(row) {
      this.$confirm(`${this.$t('toast.youAreDelTipText')} ${row.skuName} ${this.$t('SettingOrderSourceStrategyParcel.confirmText4')}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          const ids = [row.id];
          this.batchDeleteApi({ ids });
        })
        .catch(() => {});
    },
    // 列表 批量删除
    onDeleteSelected() {
      this.$confirm(`${this.$t('SettingOrderSourceStrategyParcel.confirmText2')} ${this.selectedRows.length} ${this.$t('SettingOrderSourceStrategyParcel.confirmText3')}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          const ids = this.selectedRows.map(e => e.id);
          this.batchDeleteApi({ ids });
        })
        .catch(() => {});
    },
    // 排队条件设置
    onExcludeSet() {
      this.$refs.dialogForm.show();
    },
    batchAddApi(API_DATA) {
      orderApi.addSouringStrategyPackageBatch(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      orderApi.deleteSouringStrategyPackageBatch(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
